import React, { Component } from 'react';

export default class Burger extends Component {
  // render() {
  //   const { open } = this.props;
  //   return (
  //     <svg width="24px" height="14px" viewBox="0 0 24 14">
  //       <g
  //         id="Symbols"
  //         stroke="none"
  //         strokeWidth="1"
  //         fill="none"
  //         fillRule="evenodd"
  //       >
  //         <g
  //           id="nav-/-mobile-hide"
  //           transform="translate(-200, -33.000000)"
  //           fill="#DCC08E"
  //         >
  //           <g id="nav-/-mobile">
  //             <path
  //               d="M331,33 L355,33 L355,35 L331,35 L331,33 Z M331,45 L355,45 L355,47 L331,47 L331,45 Z"
  //               id="burger"
  //             />
  //           </g>
  //         </g>
  //       </g>
  //     </svg>
  //   );
  // }

  render() {
    return (
      <div id="nav-icon4" className={`${this.props.open ? 'open' : ''}`}>
        <span />
        <span />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Burger.js